import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { RoleType } from '@wdx/clmi/clmi-swagger-gen';
import { ConfigService } from '../../services/config.service';
import { Observable } from 'rxjs';

@Injectable()
export class RolesService {
    private http = inject(HttpClient);
    private config = inject(ConfigService);


    getAll(): Observable<RoleType[]> {
        return this.http.get<RoleType[]>(
            `${this.config.getConfiguration().API_BASE}/roletype`,
        );
    }

    getByRoleType(roleType: string): Observable<RoleType> {
        return this.http.get<RoleType>(
            `${this.config.getConfiguration().API_BASE}/roletype/${roleType}`,
        );
    }

    getForClientProduct(clientProductId: string): Observable<RoleType[]> {
        return this.http.get<RoleType[]>(
            `${
                this.config.getConfiguration().API_BASE
            }/clientproduct/${clientProductId}/roles`,
        );
    }

    toogleRoleStatus(code: string, status: string) {
        return this.http.patch<RoleType>(
            `${
                this.config.getConfiguration().API_BASE
            }/roletype/${code}/status/${status}`,
            {},
        );
    }
}
